import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b1e95eb6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "relative flex py-3 pr-4 pl-7" };
const _hoisted_2 = { class: "absolute top-0 flex items-center right-4" };
const _hoisted_3 = {
    key: 0,
    class: "text-teal-600 bg-teal-100 border-teal-600 flag"
};
const _hoisted_4 = { class: "max-w-full ml-2.5 text-sm font-semibold truncate" };
const _hoisted_5 = {
    key: 0,
    class: "ml-2.5 mt-0.5 text-xs text-gray-400 leading-none"
};
const _hoisted_6 = { class: "flex flex-col justify-center ml-4" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.team_member_item')
};
import { isUser } from '@/types/user';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'MemberDrawerItem',
    props: {
        flags: null,
        member: null,
        status: null
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_avatar = _resolveComponent("avatar");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.flags, (f) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: f,
                            class: "flex items-center justify-center font-medium"
                        }, [
                            (f === 'moderator')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('moderator_flag')), 1))
                                : _createCommentVNode("", true)
                        ]));
                    }), 128))
                ]),
                _createVNode(_component_avatar, {
                    user: _unref(isUser)(__props.member) ? __props.member : null,
                    "show-tooltip": false
                }, null, 8, ["user"]),
                _createElementVNode("div", {
                    class: _normalizeClass(["flex flex-col items-start flex-1 min-w-0", __props.status ? 'justify-end' : 'justify-center'])
                }, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createTextVNode(_toDisplayString(_unref(isUser)(__props.member) ? __props.member.name : __props.member.email), 1)
                    ])), [
                        [_directive_tooltip, _unref(isUser)(__props.member) ? __props.member.name : __props.member.email]
                    ]),
                    (__props.status)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.status), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_6, [
                    _renderSlot(_ctx.$slots, "trailing")
                ])
            ]));
        };
    }
});
